<template>
  <div>
    <navigation-tabs v-show="initialized">
      <component
        v-for="(v, i) in visibleMenuList"
        :key="i"
        :is="v.disabled ? 'div' : 'router-link'"
        :to="!v.disabled ? { name: v.pathName } : undefined"
        class="tab-item"
        :class="{ disabled: v.disabled }"
      >
        {{ $t(v.name) }}
        <info-tooltip position="bottom" v-if="v.tooltip && v.tooltip.enabled" :content="v.tooltip.content" class="ml-2" />
      </component>
    </navigation-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigationTabs from '@/components/NavigationTabs'
import InfoTooltip from '@/components/utils/InfoTooltip'

export default {
  name: 'Sidebar',
  props: ['selected', 'mode'],
  components: { NavigationTabs, InfoTooltip },
  computed: {
    ...mapGetters(['initialized', 'isAdmin', 'isRedirectionTabEnabled', 'redirectionMode', 'isAvailable', 'isMenuCollapsed', 'configVersion', 'currentProduct']),

    isStcEnabled () {
      return this.redirectionMode === 'stc'
    },
    isRedirectSelected () {
      return this.selected === 'REDIRECT' || this.$route.name === 'redirect'
    },
    menuList () {
      return [
        { name: 'sidebar_redirection', pathName: 'redirect', hideTab: !this.isRedirectionTabEnabled, disabled: false },
        { name: 'sidebar_content_builder', pathName: 'config-editor', hideTab: false, disabled: (this.isRedirectSelected && !this.isStcEnabled) || !this.isAvailable('editor:tabs'), tooltip: { enabled: !this.isAvailable('editor:tabs'), content: this.$t('sidebar_upgrade_unlock_tabs') } },
        { name: 'sidebar_footer_consent', pathName: 'config-footer-consent', hideTab: false, disabled: (this.isRedirectSelected && !this.isStcEnabled) },
        { name: 'languages', pathName: 'config-global', hideTab: false, disabled: (this.isRedirectSelected && !this.isStcEnabled) || !this.isAvailable('editor:global'), tooltip: { enabled: !this.isAvailable('editor:global'), content: this.$t('sidebar_upgrade_more_languages') } },
        { name: 'sidebar_styles', pathName: 'config-design', hideTab: false, disabled: (this.isRedirectSelected && !this.isStcEnabled) || !this.isAvailable('editor:design'), tooltip: { enabled: !this.isAvailable('editor:design'), content: this.$t('sidebar_upgrade_customize_colors') } },
        { name: 'sidebar_auth_app_branding', pathName: 'config-auth-app-branding', hideTab: !this.isAvailable('editor:authentication'), disabled: (this.isRedirectSelected && !this.isStcEnabled) || !this.isAvailable('editor:authentication'), tooltip: { enabled: !this.isAvailable('editor:authentication'), content: this.$t('sidebar_upgrade_customize_auth_app') } },
        { name: 'sidebar_admin_settings', pathName: 'config-admin', hideTab: !this.isAdmin }
      ]
    },
    visibleMenuList () {
      return this.menuList.filter(item => !item.hideTab)
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
